export default {
  ASSIGN_TASKS: 'assignTasks',
  CAMUNDA: 'camunda',
  CITIES: 'cities',
  CANCEL_JOBS:'cancelJobs',
  COMMUNITIES: 'communities',
  COMPANIES: 'companies',
  COMPLETED_TASKS: 'completedTasks',
  COMPLETE_TASKS: {
    ASSIGNED_TO_USER: 'completeTasksAssignedToUser',
    NOT_ASSIGNED_TO_USER: 'completeTasksNotAssignedToUser',
  },
  DASHBOARD: 'dashboard',
  DELETE: {
    PROJECTS: 'deleteProjects',
  },
  FILES: 'files',
  HISTORY: 'history',
  IDA: 'ida',
  INSPECTIONS: 'inspections',
  INSPECTOR_APP: 'inspectorApp',
  INSPECTOR_ROUTING: 'inspectorRouting',
  IN_TOUCH: 'inTouch',
  INVOICES: 'invoices',
  JOBS: 'jobs',
  JOB_TEMPLATES: 'jobTemplates',
  JOB_TERMINATE_PROCESS_INSTANCE: 'jobTerminateProcessInstance',
  LEGAL_SUBDIVISIONS: 'legalSubdivisions',
  LINKED_TASKS: 'linkedTasks',
  MY_TASKS: 'myTasks',
  PLAN_NAMES: 'planNames',
  PRICE_RULES: 'priceRules',
  PROJECTS: 'projects',
  QB: {
    ITEM_CODES: 'itemCodes'
  },
  REPORTS: 'reports',
  STREETS: 'streets',
  SUPPLY_PRO: 'supplyPro',
  SYSTEM_TASK_VALUES: 'systemTaskValues',
  TAGS: 'inspectorAppTags',
  TASK_DUE_DATE: 'taskDueDate',
  TASK_NAMES: 'taskNames',
  TASKS: 'tasks',
  TASK_TEMPLATES: 'taskTemplates',
  TASK_TERMINATE_JOBS_TASKS: 'taskTerminateJobsTasks',
  USERS: 'users'
}
